import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { take, map } from 'rxjs/operators';
import { PaymentInstructionCodeService } from './payment-instruction-code.service';

@Pipe({
  name: 'instructionCode',
  pure: false,
  standalone: false
})
export class PaymentInstructionCodePipe implements PipeTransform, OnDestroy {
  private asyncPipe: AsyncPipe;

  constructor(
    private paymentInstructionCodeService: PaymentInstructionCodeService,
    private injector: Injector
  ) {
    this.asyncPipe = new AsyncPipe(injector.get(ChangeDetectorRef));
  }

  ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  transform(value: string): string {
    return !value
      ? ''
      : this.asyncPipe.transform(
          this.paymentInstructionCodeService.instructionCodes$.pipe(
            take(1),
            map((classifiers) => classifiers.find((classifier) => classifier.id === value)?.label)
          )
        );
  }
}
